export const navMenuButtonLogoutTranslationKeys = {
  navMenuButtonLogout: 'nav-menu.button-logout',
}

export const navMenuManagerInfoTranslationKeys = {
  navMenuButtonSendMessage: 'nav-menu.button-send-message',
  navMenuManagersContacts: 'nav-menu.managers-contacts',
}
